import { psCollection } from "./powersync-collection.js";
import {
  categorySchema,
  productSchema,
  productVariantGroupSchema,
  productVariantOptionSchema,
  addOnSchema,
  productVariantSchema,
  storeInventorySchema,
  inventoryAdjustmentSchema,
  ingredientSchema,
  productIngredientSchema,
  supplierSchema,
  purchaseOrderSchema,
  purchaseOrderItemSchema,
  stockTransferSchema,
  type Category,
  type Product,
  type ProductVariantGroup,
  type ProductVariantOption,
  type AddOn,
  type ProductVariant,
  type StoreInventory,
  type InventoryAdjustment,
  type Ingredient,
  type ProductIngredient,
  type Supplier,
  type PurchaseOrder,
  type PurchaseOrderItem,
  type StockTransfer,
} from "../schemas/catalog.js";

export const categoriesCollection = psCollection("categories", categorySchema);

export const productsCollection = psCollection("products", productSchema);

export const productVariantGroupsCollection = psCollection("product_variant_groups", productVariantGroupSchema);

export const productVariantOptionsCollection = psCollection("product_variant_options", productVariantOptionSchema);

export const addOnsCollection = psCollection("add_ons", addOnSchema);

export const productVariantsCollection = psCollection("product_variants", productVariantSchema);

export const storeInventoryCollection = psCollection("store_inventory", storeInventorySchema);

export const inventoryAdjustmentsCollection = psCollection("inventory_adjustments", inventoryAdjustmentSchema);

export const ingredientsCollection = psCollection("ingredients", ingredientSchema);

export const productIngredientsCollection = psCollection("product_ingredients", productIngredientSchema);

export const suppliersCollection = psCollection("suppliers", supplierSchema);

export const purchaseOrdersCollection = psCollection("purchase_orders", purchaseOrderSchema);

export const purchaseOrderItemsCollection = psCollection("purchase_order_items", purchaseOrderItemSchema);

export const stockTransfersCollection = psCollection("stock_transfers", stockTransferSchema);
